module.exports = __webpack_public_path__ + "static/bush2-7c1e76879d4cfcbb7bc09679d8adf5be.png";